<template>
      <section slot="pdf-content" ref="html2pdf">
        <div v-if="userData" id="prestige" ref="prestigeDocument">
          <div style="background-color: white!important;">
            <h1 class="py-base" :style="{ color: colorObj }"><b>{{ userData.firstName }} {{ userData.lastName }}</b></h1>
            <vs-row vs-type="flex" vs-justify="space-around">
              <vs-col vs-justify="center" vs-align="center" vs-sm="12" vs-w="5">
                <div class="vx-col w-full">
                    <div class="address mb-base">
                        <p v-if="userData.address">{{ userData.address }}</p><br/>  
                        <p>
                          <span v-if="userData.email">{{ userData.email }}</span><br>
                          <span v-if="userData.contactNumber">Mobile: {{ userData.contactNumber }}</span><br>
                        </p>
                    </div>

                    <div v-if="userData.profilePictureUrl" class="p_image mb-base">
                      <img :src="userProfilePicture? userProfilePicture: constants.s3Bucket +
                              '/editor/profile-pictures/' +
                              userData.profilePictureUrl
                            " class="image" alt="profile image" width="auto" height="221" style="max-height: 221px;">
                    </div>
                    <div v-else class="p_image">
                      <img src="@/assets/images/icons/gender/default.png" class="image" alt="profile image" width="auto" height="221" style="max-height: 221px;" />
                    </div>


                    <div v-if="editorData.educationalQualifications && editorData.educationalQualifications.length" class="education mb-base">
                        <h2 class="mb-base" :style="{ color: colorObj }">EDUCATION</h2>
                        <!-- <table v-for="(ch, index) in editorData.educationalQualifications" :key="index" cellpadding="0" cellspacing="0" class="tb1">
                              <tr>
                                  <td rowspan="9" width="1px">
                                    <hr/>
                                  </td>
                                  <td height="10" width="70px" valign="top">
                                    <div class="line-break1"></div><div class="line-break"></div>
                                  </td>
                                  <td  width="10" height="10" valign="top" >
                                    <div class="circle1"></div>
                                  </td> 
                                  <td width="285px"  height="10" align="right" >
                                    <p>{{ formatDate(ch.startDate) }} - {{ formatDate(ch.endDate) }}</p><br>
                                    <p>{{ ch.degreeCertification }}</p><br>
                                    <p>{{ ch.organization }}</p><br>
                                    <p>{{ ch.description }}</p><br>
                                  </td>
                              </tr>
                        </table> -->
                        <div
                          v-for="(ch, index) in editorData.educationalQualifications"
                          :key="index"
                        >
                          <div v-if="ch.degreeCertification">
                            <p class="mb-base">
                              <span><b>{{ ch.degreeCertification }} <span v-if="ch.grade">({{ch.grade}})</span></b></span><br>
                              <span v-if="ch.organization">{{ ch.organization }}<br></span>
                              <!-- <span v-if="ch.startDate || ch.endDate">{{ formatDate(ch.startDate) }} - {{ formatDate(ch.endDate) }}<br></span> -->
                              <span v-if="ch.startDate">
                                <span v-if="ch.startDate">{{ formatDate(ch.startDate) }}</span><span v-if="ch.startDate && ch.endDate"> - </span><span v-if="ch.endDate">{{ formatDate(ch.endDate) }}</span>
                                <br>
                              </span>
                              <span v-if="ch.description">{{ ch.description }}<br></span>
                            </p>
                          </div>
                        </div>
                    </div>

                    <div v-if="editorData.personality" class="personality mb-base">
                      <div
                          v-if="savedPersonalityTraits && savedPersonalityTraits.length"
                        >
                        <div v-if="organizationSlug === 'default'">
                          <div
                              v-if="
                                editorData.personality.broadcastPersonality !==
                                'dont-broadcast-my-personality'
                              "
                              class="education"
                            >
                              <h2 class="mb-base" :style="{ color: colorObj }">PERSONALITY</h2>
                              <div
                                  v-if="
                                    editorData.personality.broadcastPersonality ===
                                    'show-personality-statements'
                                  "
                                >
                                <ul v-if="editorData.personality.personalityStatements">
                                      <li
                                        v-for="(itemPr, i2) in paraToList(
                                          editorData.personality.personalityStatements
                                        )"
                                        :key="i2"
                                      >
                                        <feather-icon
                                          icon="ArrowRightCircleIcon"
                                          :style="{ color: colorObj }"
                                          svgClasses="stroke-current w-4 h-4"
                                        />
                                        {{ itemPr }}
                                      </li>
                                    </ul>
                                    <ul v-else>
                                      <li
                                        v-for="(
                                          personality, index
                                        ) in savedPersonalityTraits"
                                        :key="index"
                                      >
                                        <feather-icon
                                          icon="ArrowRightCircleIcon"
                                          :style="{ color: colorObj }"
                                          svgClasses="stroke-current w-4 h-4"
                                        />
                                        {{
                                            getPersonalityTraitById(personality.id)
                                              .iAmDescription
                                          }}
                                      </li>
                                    </ul>
                              </div>
                              <div v-else>
                                <div
                                      v-for="(
                                        personality, index
                                      ) in savedPersonalityTraits"
                                      :key="index"
                                      class="w-full"
                                    >
                                      <div v-if="index < 6">
                                        <div class="items-right">
                                          <div v-if="editorData.personality.broadcastPersonality === 'show-cloud-tag'" class="mb-base" style="width: fit-content;"> <!-- cloud tag -->
                                              <div class="cloud-tag p-1" :style="{'backgroundColor': colorSet[index]}">
                                                <h3 class="text-white">
                                                  {{
                                                    getPersonalityTraitById(personality.id)
                                                      .ability
                                                  }}
                                                </h3>
                                              </div>
                                          </div>
                                          <div v-else class="mb-base" > <!-- show icons -->
                                              <img                                    
                                                  style="height: 100px; width: auto"
                                                  class="mb-4"
                                                  :src="
                                                    getPersonalityTraitById(personality.id)
                                                      .pngIcon
                                                  "
                                                />

                                                <h3>
                                                  {{
                                                    getPersonalityTraitById(personality.id)
                                                      .ability
                                                  }}
                                                </h3>
                                          </div>                              
                                        </div>                          
                                      </div>
                                    </div>
                              </div>

                          </div>
                        </div>
                        <div v-else-if="organizationSlug === 'dpd-belux'">
                          <div
                              v-if="
                                editorData.personality.broadcastPersonalityDpdBelux !==
                                'dont-broadcast-my-personality'
                              "
                              class="education"
                            >
                              <h2 class="mb-base" :style="{ color: colorObj }">COMPETENCY</h2>
                              <div
                                  v-if="
                                    editorData.personality.broadcastPersonalityDpdBelux ===
                                    'show-personality-statements'
                                  "
                                >
                                <ul v-if="editorData.personality.personalityStatementsDpdBelux">
                                      <li
                                        v-for="(itemPr, i2) in paraToList(
                                          editorData.personality.personalityStatementsDpdBelux
                                        )"
                                        :key="i2"
                                      >
                                        <feather-icon
                                          icon="ArrowRightCircleIcon"
                                          :style="{ color: colorObj }"
                                          svgClasses="stroke-current w-4 h-4"
                                        />
                                        {{ itemPr }}
                                      </li>
                                </ul>
                                <ul v-else>
                                  <li
                                    v-for="(
                                      personality, index
                                    ) in savedPersonalityTraits"
                                    :key="index"
                                  >
                                    <feather-icon
                                      icon="ArrowRightCircleIcon"
                                      :style="{ color: colorObj }"
                                      svgClasses="stroke-current w-4 h-4"
                                    />
                                    {{
                                        getPersonalityTraitById(personality.id)
                                          .description
                                      }}
                                  </li>
                                </ul>
                              </div>
                              <div v-else>
                                <div
                                      v-for="(
                                        personality, index
                                      ) in savedPersonalityTraits"
                                      :key="index"
                                      class="w-full"
                                    >
                                      <div v-if="index < 6">
                                        <div class="items-right">
                                          <div v-if="editorData.personality.broadcastPersonalityDpdBelux === 'show-cloud-tag'" class="mb-base" style="width: fit-content;"> <!-- cloud tag -->
                                              <div class="cloud-tag" :style="{'backgroundColor': colorSet[index]}">
                                                <h3>
                                                  {{
                                                    getPersonalityTraitById(personality.id)
                                                      .ability
                                                  }}
                                                </h3>
                                              </div>
                                          </div>
                                          <div v-else class="mb-base" > <!-- show icons -->
                                              <img                                    
                                                  style="height: 100px; width: auto"
                                                  class="mb-4"
                                                  :src="
                                                    getPersonalityTraitById(personality.id)
                                                      .pngIcon
                                                  "
                                                />

                                                <h3>
                                                  {{
                                                    getPersonalityTraitById(personality.id)
                                                      .ability
                                                  }}
                                                </h3>
                                          </div>                              
                                        </div>                          
                                      </div>
                                    </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="
                            editorData.extraCurricular.hobbies &&
                            editorData.extraCurricular.hobbies.length
                          " class="hobbies mb-base">
                      <h2 class="mb-base" :style="{ color: colorObj }">HOBBIES</h2>
                      <p v-for="(hobby, index) in editorData.extraCurricular.hobbies" :key="index" class="mb-5">
                        <vs-icon
                                v-if="hobby.icon"
                                :icon="hobby.icon"
                                size="small"
                              />
                        {{ hobby.metaData.label }}
                      </p>
                    </div>

                    <!-- <div class="Awards mb-base">
                      <h2>AWARDS</h2>
                      <p>Best UX/UI designer<br>(Google)</p>
                      <p>Product Manager of the year<br>(Google)
                      </p>
                    </div> -->

                    <!-- <div class="video">
                      <h2>VIDEO</h2>
                      <p>Space For Video</p>
                    </div> -->
                    <!-- <div class="Recommendation">
                      <h2>RECOMMENDATIONS</h2>
                      <table class="tb2">
                          <tr>
                          <td><img src="Images/recomdation3.jpg" width="80px" height="96px" valign="top" ></td>
                          <td colspan="5" width="268px">Bernard Bonomi(Yahoo!)<br>                    
                                      Marissa was creative and<br>    
                                      quiet. She designed our<br>
                                      website based on<br>
                                      incoherent help.</td></tr>
                          <tr> <td><br></td></tr>
                                      <tr>
                                      <td ><img src="Images/recomdation2.jpg"   valign="top" width="80px" height="96px"></td>
                                      <td colspan="5" width="268px"><b>Rodrigo </b>(Google)<br>
                                      Marissa has been a <br>
                                      phenomenal find for us for <br>
                                      all our graphic design <br>
                                      needs.She’s a jack-of<br>
                                      -all trades when it comes.
                                      </td>
                                      </tr>
                      </table>
                    </div> -->
                    <!-- <div class="contact">
                      <h2>CONTACT</h2>
                      <input type="" class="n">
                    </div> -->
                </div>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-sm="12" vs-w="5">
                <div class="vx-col w-full">
                    <div v-if="editorData.careerHistory && editorData.careerHistory.length" class="Experience mb-base">
                        <h2 class="mb-base" :style="{ color: colorObj }">EXPERIENCE</h2>
                        <div v-for="(ch, index) in editorData.careerHistory" :key="index">
                          <p v-for="(pr, indexPr) in ch.promotions"
                              :key="indexPr" class="mb-base">
                            <b>{{ pr.title }}</b><br>
                            {{ pr.company }}<br>
                            <!-- {{ formatDate(pr.startDate) }} - {{ formatDate(pr.endDate) }}<br> -->
                            <span v-if="pr.startDate">
                              <span v-if="pr.startDate">{{ formatDate(pr.startDate) }}</span>
                              <span v-if="pr.startDate && pr.endDate"> - </span>
                              <span v-if="pr.currentlyActive">Present</span>
                              <span v-else-if="pr.endDate">{{ formatDate(pr.endDate) }}</span>
                            </span>
                            <ul>
                              <li
                                v-for="(itemPr, i2) in paraToList(pr.description)"
                                :key="i2"
                              >
                                <feather-icon
                                  icon="ArrowRightCircleIcon"
                                  :style="{ color: colorObj }"
                                  svgClasses="stroke-current w-4 h-4"
                                />
                                {{ itemPr }}
                              </li>
                            </ul>
                          </p>
                          <p class="mb-base">
                            <b>{{ ch.title }}</b><br>
                            {{ ch.company }}<br>
                            <!-- {{ formatDate(ch.startDate) }} - {{ formatDate(ch.endDate) }}<br> -->
                            <span v-if="ch.startDate">
                              <span v-if="ch.startDate">{{ formatDate(ch.startDate) }}</span>
                              <span v-if="ch.startDate && ch.endDate"> - </span>
                              <span v-if="ch.currentlyActive">Present</span>
                              <span v-else-if="ch.endDate">{{ formatDate(ch.endDate) }}</span>
                            </span><br>
                            <ul>
                              <li
                                v-for="(itemCh, i2) in paraToList(ch.description)"
                                :key="i2"
                              >
                                <feather-icon
                                  icon="ArrowRightCircleIcon"
                                  :style="{ color: colorObj }"
                                  svgClasses="stroke-current w-4 h-4"
                                />
                                {{ itemCh }}
                              </li>
                            </ul>
                          </p>
                        </div>
                    </div>

                    <div v-if="
                            editorData.extraCurricular.languages &&
                            editorData.extraCurricular.languages.length
                          " class="language mb-base">
                        <h2 class="mb-base" :style="{ color: colorObj }">LANGUAGES</h2>
                        <table cellpadding="3" class="tb3">
                          <tr v-for="(language, index) in editorData.extraCurricular.languages" :key="index" class="mb-5">
                              <td class="w">{{ language.title.label.toUpperCase() }}</td>
                              <td><div class="circle" :class="{'greyDot' : parseInt(language.level) < 1}"></div></td>
                              <td><div class="circle" :class="{'greyDot' : parseInt(language.level) < 2}"></div></td>
                              <td><div class="circle" :class="{'greyDot' : parseInt(language.level) < 3}"></div></td>
                              <td><div class="circle" :class="{'greyDot' : parseInt(language.level) < 4}"></div></td>
                              <td><div class="circle" :class="{'greyDot' : parseInt(language.level) < 5}"></div></td>
                          </tr>
                        </table>
                    </div>

                    <div v-if="
                            editorData.extraCurricular.skills &&
                            editorData.extraCurricular.skills.length
                          " class="skill mb-base">
                        <h2 class="mb-base" :style="{ color: colorObj }">SKILLS</h2>
                        <table cellpadding="3" class="tb3">
                            <tr v-for="(skill, index) in editorData.extraCurricular.skills" :key="index" height="50">
                                <td class="w">{{ skill.title.toUpperCase() }}</td>
                                <td><div class="circle" :class="{'greyDot' : parseInt(skill.level) < 1}"></div></td>
                                <td><div class="circle" :class="{'greyDot' : parseInt(skill.level) < 2}"></div></td>
                                <td><div class="circle" :class="{'greyDot' : parseInt(skill.level) < 3}"></div></td>
                                <td><div class="circle" :class="{'greyDot' : parseInt(skill.level) < 4}"></div></td>
                                <td><div class="circle" :class="{'greyDot' : parseInt(skill.level) < 5}"></div></td>
                            </tr>
                        </table>
                    </div>

                    <div v-if="editorData.projects && editorData.projects.length" class="project mb-base">
                        <h2 class="mb-base" :style="{ color: colorObj }">PROJECTS</h2>
                        <div v-for="(project, index) in editorData.projects"
                              :key="index" class="mb-base">
                              <div v-if="project.title">
                                <!-- <img src="Images/project1.jpg" id="pro_img" alt="project image" width="180px" height="83px" float="right"> -->
                                <img
                                  v-if="project.projectPictureUrl"
                                          style="height: 150px; width: 100%"
                                          class="portfolio-img mb-4"
                                          crossorigin="anonymous"
                                          :src="
                                            constants.s3Bucket +
                                            '/editor/project-pictures/' +
                                            project.projectPictureUrl
                                          "
                                        />
                                <h2 :style="{ color: colorObj }">{{ project.title }}</h2>
                                <p>
                                        {{ project.description }}
                                </p>
                              </div>
                    </div>
                    </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </section>
</template>

<script>
import constants from "@/constants";
import moment from "moment";
import * as imageToBase64 from "image-to-base64";
import StarRating from "vue-star-rating";
import WorldMap from "./WorldMap";
// import personalityData from "@/assets/data/personality.js";
import organizationConfig from "@/assets/data/organization-config.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  components: { StarRating, WorldMap },
  data() {
    return {
      htmlToPdfOptions: {},
      constants,
      map: {
        defaultCountryFillColor: "white",
        highColor: this.colorObj,
        lowColor: this.colorObj,
        countryStrokeColor: "black",
      },
      visitedCountries: {
        US: 101,
        NZ: 101,
        UK: 101,
        IN: 103,
      },
      // personalityData,
      colorSet: [
        "#008000",
        "#3BA0BE",
        "#6859B4",
        "#E4D033",
        "#EA7526",
        "#C6211B",
        "#F36677",
        "#B3B3B3",
      ],
      userProfilePicture: null,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    editorData() {
      return this.$store.state.editor;
    },
    extraCurricular() {
      return this.$store.state.editor.extraCurricular;
    },
    colorObj() {
      return this.userData.templateColorCode;
    },
    backgroundColorObj() {
      return { backgroundColor: this.userData.templateColorCode };
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      return organizationConfig[this.organizationSlug].personalityTraits[
        this.locale
      ];
    },
    savedPersonalityTraits() {
      let personalityTraits = [];

      // For Dpd Belux
      if (this.organizationSlug === "dpd-belux") {
        if (
          !this.editorData.personality ||
          !this.editorData.personality.personalityTraitsDpdBelux
        )
          return [];
        this.editorData.personality.personalityTraitsDpdBelux.forEach((pt) => {
          this.personalityData.forEach((pt2) => {
            if (pt.id === pt2.id) {
              personalityTraits.push(pt);
            }
          });
        });
      } else {
        if (
          !this.editorData.personality ||
          !this.editorData.personality.personalityTraits
        )
          return [];
        this.editorData.personality.personalityTraits.forEach((pt) => {
          this.personalityData.forEach((pt2) => {
            if (pt.id === pt2.id) {
              personalityTraits.push(pt);
            }
          });
        });
      }

      return personalityTraits;
    },
  },
  watch: {
    colorObj(newVal) {
      if (newVal) {
        // // console.log(newVal);
        this.map.highColor = newVal;
        this.map.lowColor = newVal;
        this.$forceUpdate();
      }
    },
    userData(newVal) {
      this.converImgToBase64(
        `${this.constants.s3Bucket}/editor/profile-pictures/${newVal.profilePictureUrl}`
      );
    },
  },
  methods: {
    async converImgToBase64(url) {
      try {
        // # is added for a fresh server load
        const data = await fetch(url + "?#" + new Date().getTime());
        // // console.log(data);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            this.userProfilePicture = base64data;
            // // console.log(this.userProfilePicture);
            resolve(base64data);
          };
        });
      } catch (err) {
        throw err;
      }
    },
    getPersonalityTraitById(id) {
      const p = this.personalityData.find((pd) => pd.id === id);
      return p;
    },
    async generatePDF() {
      // this.$refs.html2Pdf.generatePdf();

      /*html2pdf(this.$refs.prestigeDocument, {
					margin: 0,
					filename: `${this.userData.firstName}-${this.userData.lastName}.pdf`,
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: {scale: 4, dpi: 192, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
          enableLinks: true,
          pagebreak: { mode: ['avoid-all'] },
				}).then(() => {
          this.$vs.loading.close();
        })*/

      const pdfName = `${this.userData.firstName}-${this.userData.lastName}.pdf`;
      const vsLoading = this.$vs.loading;

      await html2canvas(this.$refs.prestigeDocument).then(function (canvas) {
        var a = document.createElement("a");
        // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
        a.href = canvas.toDataURL("image/jpeg", 1.0);
        // a.download = 'somefilename.jpeg';
        // a.click();

        const img = new Image();
        img.onload = async function () {
          // // console.log(this.width + 'x' + this.height);
          let pdf = new jsPDF("p", "px", [this.width, this.height]);
          if (this.width > this.height) {
            pdf = new jsPDF("l", "px", [this.width, this.height]);
          }
          await pdf.addImage(a.href, "JPEG", 0, 0, this.width, this.height);
          await pdf.save(pdfName);
          vsLoading.close();
        };
        img.src = a.href;
      });
    },
    startPagination() {
      // this.$vs.loading();
    },
    onProgressDownload(ev) {},
    hasDownloaded() {
      this.$vs.loading.close();
    },
    async imgToBase64(img) {
      let imgRes = "";
      await imageToBase64(img)
        .then((res) => {
          imgRes = res;
          return res;
        })
        .catch((err) => {
          throw err;
        });

      return imgRes;
    },
    paraToList(para) {
      if (para) {
        let lst = para.match(/[^\.!\?]+[\.!\?]+/g);
        if (lst && lst.length) {
          return lst;
        } else {
          return [para];
        }
      }
      return [];
    },
    formatDate(date) {
      return moment(date).format("MMM YYYY");
    },
  },
  mounted() {
    this.$root.$on("downloadResume", () => {
      this.generatePDF();
    });

    // convert profile picture to base64
    if (this.userData && this.userData.profilePictureUrl) {
      // // console.log(this.userData);
      console.log(`${this.constants.s3Bucket}/editor/profile-pictures/${this.userData.profilePictureUrl}`);
      this.converImgToBase64(
        `${this.constants.s3Bucket}/editor/profile-pictures/${this.userData.profilePictureUrl}`
      );
    }
  },
};
</script>



<style scoped>
html,
body {
  font-family: "Roboto";
}

h1 {
  text-align: center;
  font-size: 32px;
  color: orange;
}
h1 b {
  text-transform: uppercase;
}
h2 {
  font-size: 24px;
  color: orange;
}
h3 {
  font-size: 18.666px;
}
h4 {
  font-size: 16px;
}

p {
  font-size: 18.666px;
}
img {
  -webkit-filter: grayscale(); /* Safari 6.0 - 9.0 */
  filter: grayscale();
}

.container {
  width: 1280px;
  margin: 0px auto;
}
.circle {
  background: none repeat scroll 0 0 orange;
  border-radius: 50px;
  display: table-cell;
  height: 15px;
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
  width: 15px;
}
.circle1 {
  background: none repeat scroll 0 0 orange;
  border-radius: 50px;
  display: table-cell;
  height: 10px;
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
  width: 10px;
}

td {
  font-size: 18.66px;
}
.tb {
  margin-left: 300px;
}
.tb1 {
  margin-left: 225px;
}
.tb2 {
  margin-left: 268px;
}
.w {
  width: 196px;
}
hr {
  width: 1px;
  height: 380px;
  border: none;
  border-left: 3px dotted orange;
  float: left;
}
.line-break {
  width: 85px;
  height: 1px;
  border-top: 3px dotted orange;
  margin: 0 auto;
  margin-left: 0px;
}

.line-break1 {
  width: 85px;
  height: 1px;
  border-top: 3px solid white;
  margin: 0 auto;
  margin-left: 0px;
}

.address,
.p_image,
.education,
.hobbies,
.personality,
.video,
.Awards,
.Recommendation,
.contact {
  margin-rightt: 680px;
  text-align: right;
}

.image {
  /*margin-left: 268px;*/
}
#right {
  margin-left: 660px;
  text-align: left;
  margin-top: -2125px;
}

.recom {
  margin-top: 10px;
}

.n {
  border: 3px solid orange;
  height: 30px;
  background-color: orange;
}

.contact1 {
  margin-top: 26px;
}

/**
  Custom for template
*/

.greyDot {
  background: none repeat scroll 0 0 #ccd1d1;
}

.cloud-tag {
  padding: 8px 10px;
  background-color: blue;
  border-radius: 8px;
}

.cloud-tag h3 {
  color: white;
  margin: 0 !important;
}

@media screen and (max-width: 1024px) {
  html,
  body {
    font-family: "Roboto";
  }

  h1 {
    text-align: center;
    font-size: 32px;
    color: orange;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.666px;
  }
  h4 {
    font-size: 16px;
  }

  p {
    font-size: 18.666px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    font-size: 14px;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    color: red;
    display: table-cell;
    font-size: 14px;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 228px;
  }
  .tb1 {
    margin-left: 215px;
  }
  .tb2 {
    margin-left: 228px;
  }
  .w {
    width: 196px;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .p_image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation,
  .contact {
    margin-rightt: 720px;
    text-align: right;
  }

  .image {
    margin-left: 228px;
  }
  #right {
    margin-left: 680px;
    text-align: left;
    margin-top: -2125px;
  }

  .recom {
    margin-top: 10px;
  }

  .n {
    border: 3px solid orange;
    height: 30px;
    background-color: orange;
  }

  .contact1 {
    margin-top: 27px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  html,
  body {
    font-family: "Roboto";
  }

  h1 {
    text-align: center;
    font-size: 32px;
    color: orange;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.666px;
  }
  h4 {
    font-size: 16px;
  }

  p {
    font-size: 18.666px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    font-size: 14px;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    color: red;
    display: table-cell;
    font-size: 14px;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .w {
    width: 196px;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .p_image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation,
  .contact {
    margin-rightt: 404px;
    text-align: right;
  }

  .image {
    margin-left: 38px;
  }
  #right {
    margin-left: 444px;
    text-align: left;
    margin-top: -2125px;
  }

  .recom {
    margin-top: 10px;
  }

  .n {
    border: 3px solid orange;
    height: 30px;
    background-color: orange;
  }

  .container {
    width: 780px;
  }
  .contact1 {
    margin-top: 27px;
  }
}

@media screen and (min-width: 640px) and (max-width: 767px) {
  html,
  body {
    font-family: "Roboto";
  }

  h1 {
    text-align: center;
    font-size: 32px;
    color: orange;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.666px;
  }
  h4 {
    font-size: 16px;
  }

  p {
    font-size: 18.666px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    font-size: 14px;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    color: red;
    display: table-cell;
    font-size: 14px;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .w {
    width: 146px;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .p_image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation,
  .contact {
    margin-rightt: 340px;
    text-align: right;
  }

  .image {
    margin-left: 25px;
    width: 275px;
  }
  #right {
    margin-left: 360px;
    text-align: left;
    margin-top: -2255px;
  }

  .recom {
    margin-top: 10px;
  }

  .n {
    border: 3px solid orange;
    height: 30px;
    background-color: orange;
  }

  .container {
    width: 640px;
  }
  .contact1 {
    margin-top: 155px;
  }
}

@media screen and (min-width: 568px) and (max-width: 639px) {
  html,
  body {
    font-family: "Roboto";
  }

  h1 {
    text-align: center;
    font-size: 32px;
    color: orange;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.666px;
  }
  h4 {
    font-size: 16px;
  }

  p {
    font-size: 18.666px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    font-size: 14px;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    color: red;
    display: table-cell;
    font-size: 14px;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .w {
    width: 146px;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .p_image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation,
  .contact {
    margin-rightt: 304px;
    text-align: right;
  }

  .image {
    margin-left: 20px;
    width: 245px;
  }
  #right {
    margin-left: 324px;
    text-align: left;
    margin-top: -2330px;
    width: 284px;
  }

  .recom {
    margin-top: 10px;
  }

  .n {
    border: 3px solid orange;
    height: 30px;
    background-color: orange;
  }

  .container {
    width: 568px;
  }
  .contact1 {
    margin-top: 230px;
  }
}

@media screen and (min-width: 376px) and (max-width: 567px) {
  h1 {
    width: 412px;
    text-align: center;
    font-size: 32px;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.66px;
  }
  h4 {
    font-size: 16px;
  }

  p {
    font-size: 18.66px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .tb3 {
    margin-left: 40px;
    float: right;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }
  .container {
    float: center;
    width: 414;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation,
  .contact {
    margin-rightt: 80px;
    text-align: right;
    width: 350px;
  }

  .image {
    margin-rightt: 65px;
    float: right;
    width: 320px;
  }
  .education {
    margin-top: 173px;
  }
  #pro_img {
    width: 140px;
    height: 80px;
  }

  #right {
    margin-left: -60px;
    text-align: right;
    margin-top: 0px;
    width: 414px;
    float: left;
  }
  #left {
    width: 414px;
    text-align: right;
  }

  .imag {
    margin-right: 180px;
    vertical-align: middle;
  }
  .recom {
    margin-top: 10px;
  }
  .img-valign {
    vertical-align: middle;
    width: 110px;
    height: 100px;
  }

  .text1,
  .text2 {
    font-size: 14px;
  }
  .n {
    border: 3px solid gray;
    height: 30px;
  }
  #p1 {
    width: 21;
    height: 21;
  }
}
@media screen and (max-width: 375px) {
  h1 {
    text-align: center;
    font-size: 24px;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.66px;
  }
  h4 {
    font-size: 16px;
  }
  .container {
    width: 375px;
  }

  p {
    font-size: 18.66px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .tb3 {
    margin-left: 10px;
    float: right;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation {
    margin-rightt: 80px;
    text-align: right;
  }

  .contact {
    text-align: right;
    margin-rightt: 80px;
  }

  .image {
    margin-rightt: 80px;
    float: right;
    width: 250px;
  }
  .education {
    margin-top: 173px;
  }
  #pro_img {
    width: 140px;
    height: 80px;
  }

  #right {
    margin-left: -80px;
    text-align: right;
    margin-top: 0px;
    width: 375px;
    float: left;
  }
  #left {
    width: 375px;
    text-align: right;
  }

  .imag {
    margin-rightt: 180px;
    vertical-align: middle;
  }
  .recom {
    margin-top: 10px;
  }
  .img-valign {
    vertical-align: middle;
    width: 110px;
    height: 100px;
  }

  .text1,
  .text2 {
    font-size: 14px;
  }
  .n {
    border: 3px solid gray;
    height: 30px;
  }
  #p1 {
    width: 21;
    height: 21;
  }
}

@media screen and (max-width: 360px) {
  h1 {
    text-align: center;
    font-size: 24px;
  }
  h2 {
    font-size: 24px;
    color: orange;
  }
  h3 {
    font-size: 18.66px;
  }
  h4 {
    font-size: 16px;
  }
  .container {
    width: 375px;
  }

  p {
    font-size: 18.66px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .tb3 {
    margin-left: 10px;
    float: right;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation {
    margin-rightt: 80px;
    text-align: right;
  }

  .contact {
    text-align: right;
    margin-rightt: 80px;
  }

  .image {
    margin-rightt: 80px;
    float: right;
    width: 250px;
  }
  .education {
    margin-top: 173px;
  }
  #pro_img {
    width: 140px;
    height: 80px;
  }

  #right {
    margin-left: -80px;
    text-align: right;
    margin-top: 0px;
    width: 360px;
    float: left;
  }
  #left {
    width: 360px;
    text-align: right;
  }

  .imag {
    margin-rightt: 180px;
    vertical-align: middle;
  }
  .recom {
    margin-top: 10px;
  }
  .img-valign {
    vertical-align: middle;
    width: 110px;
    height: 100px;
  }

  .text1,
  .text2 {
    font-size: 14px;
  }
  .n {
    border: 3px solid gray;
    height: 30px;
  }
  #p1 {
    width: 21;
    height: 21;
  }
}

@media screen and (max-width: 320px) {
  h1 {
    text-align: center;
    font-size: 24px;
  }
  h2 {
    font-size: 18px;
    color: orange;
  }
  h3 {
    font-size: 14px;
  }
  h4 {
    font-size: 12px;
  }

  p {
    font-size: 16px;
  }
  .container {
    width: 320px;
  }
  .circle {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 15px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 15px;
  }
  .circle1 {
    background: none repeat scroll 0 0 orange;
    border-radius: 50px;
    display: table-cell;
    height: 10px;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    width: 10px;
  }

  td {
    font-size: 18.66px;
  }
  .tb {
    margin-left: 10px;
  }
  .tb1 {
    margin-left: 10px;
  }
  .tb2 {
    margin-left: 10px;
  }
  .tb3 {
    margin-left: 10px;
    float: right;
  }
  hr {
    width: 1px;
    height: 380px;
    border: none;
    border-left: 3px dotted orange;
    float: left;
  }
  .line-break {
    width: 85px;
    height: 1px;
    border-top: 3px dotted orange;
    margin: 0 auto;
    margin-left: 0px;
  }

  .line-break1 {
    width: 85px;
    height: 1px;
    border-top: 3px solid white;
    margin: 0 auto;
    margin-left: 0px;
  }

  .address,
  .image,
  .education,
  .hobbies,
  .personality,
  .video,
  .Awards,
  .Recommendation {
    margin-rightt: 50px;
    text-align: right;
  }

  .contact {
    text-align: right;
    margin-rightt: 50px;
  }

  .image {
    margin-rightt: 50px;
    float: right;
    width: 250px;
  }
  .education {
    margin-top: 173px;
  }
  #pro_img {
    width: 140px;
    height: 80px;
  }

  #right {
    margin-left: -50px;
    text-align: right;
    margin-top: 0px;
    width: 320px;
    float: left;
  }
  #left {
    width: 320px;
    text-align: right;
  }

  .imag {
    margin-rightt: 180px;
    vertical-align: middle;
  }
  .recom {
    margin-top: 10px;
  }
  .img-valign {
    vertical-align: middle;
    width: 110px;
    height: 100px;
  }

  .text1,
  .text2 {
    font-size: 14px;
  }
  .n {
    border: 3px solid gray;
    height: 30px;
  }
  #p1 {
    width: 21;
    height: 21;
  }
}
</style>